import { useEffect } from "react";

const APP_SHELL_REGIONS = [
  "[data-app-shell-sidebar]",
  "[data-app-shell-main]",
  "[data-app-shell-mobile-nav]"
];

export default function useAppShellModalIsolation(active) {
  useEffect(() => {
    if (!active) return undefined;

    const regions = APP_SHELL_REGIONS
      .map(selector => document.querySelector(selector))
      .filter(Boolean);
    const previous = regions.map(element => ({
      element,
      inert: element.hasAttribute("inert"),
      ariaHidden: element.getAttribute("aria-hidden")
    }));
    const previousOverflow = document.body.style.overflow;

    for (const element of regions) {
      element.setAttribute("inert", "");
      element.setAttribute("aria-hidden", "true");
    }
    document.body.style.overflow = "hidden";

    return () => {
      for (const state of previous) {
        if (!state.inert) state.element.removeAttribute("inert");
        if (state.ariaHidden === null) state.element.removeAttribute("aria-hidden");
        else state.element.setAttribute("aria-hidden", state.ariaHidden);
      }
      document.body.style.overflow = previousOverflow;
    };
  }, [active]);
}
